import React from "react";

export const Support = (props) => {
  return (
    <div>
      <div id="support">
        <div className="container">
          <h1>Support</h1>
          <p>If you need help, please reach out to us at support@bleamlabs.com</p>
         </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; Leanrtastic @ 2023
          </p>
        </div>
      </div>
    </div>
  );
};
